import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const ADMIN_PASSWORD_KEY = "carwash_admin_password";

export function getAdminPassword() {
    return localStorage.getItem(ADMIN_PASSWORD_KEY) || "";
}

export function setAdminPassword(pw) {
    localStorage.setItem(ADMIN_PASSWORD_KEY, pw);
}

export function clearAdminPassword() {
    localStorage.removeItem(ADMIN_PASSWORD_KEY);
}

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
    const pw = getAdminPassword();
    if (pw) config.headers["x-admin-password"] = pw;
    return config;
});
